<template>
    <v-button
      class="navbar-mobile-search__open"
      label="Toggle Search"
      @click="toggleSearch"
      v-if="showSearch === false || $mq === 'mobile' || $mq === 'tablet'"
    >
      <icon name="search" size="18px"></icon>
    </v-button>
    <transition name="slide-fade-down" v-else>
      <div class="navbar-mobile-search">
        <search-form @close-search="closeSearch"></search-form>
      </div>
    </transition>
</template>

<script>
import SearchForm from '@/scripts/components/forms/SearchForm.vue'
import VButton from '@/scripts/components/buttons/VButton.vue'
import Icon from '@/scripts/components/basic/Icon.vue'

export default {
  name: 'NavbarMobileSearch',
  components: { SearchForm, VButton, Icon },
  data () {
    return {
      showSearch: false
    }
  },
  methods: {
    openSearch () {
      this.showSearch = true
    },
    closeSearch () {
      this.showSearch = false
    },
    toggleSearch () {
      if (this.showSearch) {
        this.closeSearch()
      } else {
        this.openSearch()
      }
      this.$emit('toggle-search')
    }
  }
}
</script>

<style scoped lang="scss">
.navbar-mobile-search {
  position: absolute;
  top: 54px;
  left: 0;
  display: flex;
  align-items: center;
  width: 100%;
  height: 100px;
  padding: 24px 13px;
  z-index: 999;
  &__open {
    /* margin-left: auto; */
    margin-right: 22px;

    &:focus {
      background-color: transparent;
    }
  }
}
</style>
